@if (vm$ | async; as vm) {
    @if (vm.isAccaBoostApplied) {
        <span class="acca-boost-icon">
            <bs-acca-boost-icon />
        </span>
    }
    <div class="possible-winnings">
        <span class="possible-winnings-text" [ngClass]="{ updated: event.isSelected }">{{ vm.possibleWinningsText }}</span>
        @if (!event.isSelected) {
            <span class="possible-winnings-old {{ vm.strikeOutClass }}">{{ vm.currentWins }}</span>
            <span class="possible-winnings-updated">{{ vm.upsellWins }}</span>
        }
    </div>
}
